import { Injectable } from '@angular/core';
import { RuntimeConfigService } from '../config/runtime-config.service';

@Injectable({ providedIn: 'root' })
export class VersionToggleService {
  private readonly _isV2: boolean;

  constructor(private runtimeConfigService: RuntimeConfigService) {
    this._isV2 = this.runtimeConfigService.appVersion === 'v2';
  }

  get isV2(): boolean {
    return this._isV2;
  }
}
